import styled from '@emotion/styled';
import { BaseButton } from '../base';

export const Container = styled.div`
    width: 100%;
    height: 100vh;
    position: relative;
    display: flex;
    flex-direction: column;
`;

export const PdfContainer = styled.div`
    width: 100%;
    height: 100%;
    min-height: 0;
    overflow: hidden;
`;

export const ImageContainer = styled.div`
    width: 100%;
    height: 100%;
    min-height: 0;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    background-color: #f5f5f5;
    padding: 0;
`;
export const RotateButton = styled(BaseButton)`
    border: none;
    min-width: 40px;
    padding: 0;
`;
export const UnsupportedContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f5f5f5;
    padding: 20px;
`;

export const UnsupportedMessage = styled.div`
    text-align: center;
    max-width: 400px;

    h3 {
        margin-bottom: 16px;
        color: #333;
        font-size: 18px;
    }

    p {
        margin-bottom: 24px;
        color: #666;
        font-size: 14px;
    }
`;

export const FallbackActions = styled.div`
    display: flex;
    gap: 12px;
    justify-content: center;
`;

export const LoadingContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;

    div {
        padding: 20px;
        background-color: white;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
`;
